<template>
  <div class="ya-te-font-line">
    <!-- カバーエリア -->
    <section class="ya-te-lp-cover-area px-4">
      <div class="co-container-md ya-te-text-primary relative mx-auto mt-[14.6875rem] md:mt-8">
        <h1 class="mb-9 md:mb-10">
          <img
            class="ya-te-lp-cover-title mx-auto md:mx-0"
            src="~/assets/images/YaTe/YaTeCounseling/Cover/cover-title-ly.svg"
            alt="ここで学べば間違いない 働きながらでもスキルが身につくオンラインプログラミングスクール"
            width="459"
            height="154"
          >
        </h1>
        <div class="text-center md:text-left">
          <a
            v-if="opening"
            class="ya-te-btn relative inline-block px-8 py-4 text-center font-bold hover:opacity-80"
            href="#schedule"
            @click.prevent="scrollTo('schedule')"
          >
            <div class="ya-te-btn-label absolute w-full">
              <div class="ya-te-btn-label-inner co-display-12 inline-block rounded-full border bg-white px-5">
                <span class="font-bold">当日1時間後からOK</span>
              </div>
            </div>
            <span class="text-white">無料相談を予約する</span>
          </a>
        </div>
        <div class="my-3 text-[.625rem] leading-normal text-co-gray-500 md:w-[20.25rem]">
          ※LINEヤフーテックアカデミーはLINEヤフーとテックアカデミー（ブリューアス社運営）が共同開発・運営するプログラミングスクールです
        </div>
      </div>
    </section>

    <!-- 無料相談の特典 -->
    <YaTeCounselingSpecial class="ya-te-fixed-button-start" />

    <!-- こんな方におすすめ -->
    <YaTeCounselingTarget class="!bg-white">
      <template #leadCopy>
        <ul class="co-display-9 flex flex-col gap-3 font-bold">
          <li>現職でキャリアアップ<br class="md:hidden">するために学びたい</li>
          <li>ITに興味があり、<br class="md:hidden">プログラミングを学んでみたい</li>
          <li>ITスキルを身につけたい</li>
        </ul>
      </template>
    </YaTeCounselingTarget>

    <!-- 3つの特徴 -->
    <YaTeCounselingFeatures />

    <!-- 数字でわかるLINEヤフーテックアカデミー -->
    <YaTeCounselingStatistics />

    <!-- まずはお気軽にご相談ください -->
    <YaTeCounselingConsultation :opening="opening">
      <template #leadText>
        カウンセラーが、目標や悩み・疑問も丁寧にヒアリング。<br class="hidden md:block">コースやサポートについての質問はもちろん、働きながら学ぶことやキャリアへの活かし方まで<br class="hidden md:block">なんでもご相談いただけます。
      </template>
      <template #questionImage01>
        <img
          class="mx-auto md:mx-0"
          src="~/assets/images/YaTe/YaTeCounseling/Consultation/question-1-ly.svg"
          alt="本当に未経験からでも転職できるの？"
          width="207"
          height="98"
          loading="lazy"
        >
      </template>
      <template #questionImage02>
        <img
          class="mx-auto md:mx-0"
          src="~/assets/images/YaTe/YaTeCounseling/Consultation/question-2-ly.svg"
          alt="ITエンジニアの仕事って自分に向いているの？"
          width="207"
          height="98"
          loading="lazy"
        >
      </template>
    </YaTeCounselingConsultation>

    <!-- カリキュラム -->
    <YaTeCounselingCurriculum>
      <template #text3>
        Webアプリケーションの仕組みを理解し
        <br>
        実際に作れるようになる。
      </template>
    </YaTeCounselingCurriculum>

    <!-- メンターサポート -->
    <YaTeCounselingMentorSupport />

    <!-- コースのご案内 -->
    <section class="ya-te-bg-gray">
      <div class="co-container-md mx-auto px-4 py-20">
        <h2 class="ya-te-page-title ya-te-text-primary mb-12 text-center font-extrabold leading-normal">
          コースのご案内
        </h2>
        <!-- テーブル -->
        <div class="ya-te-course-table mb-2 flex flex-row items-end justify-center gap-1 text-center">
          <!-- 見出し -->
          <div>
            <div class="ya-te-course-th co-display-13 flex items-center justify-center border-x border-t border-co-gray-300 bg-white font-bold">
              期間
            </div>
            <div class="ya-te-course-th co-display-13 flex items-center justify-center border-x border-t border-co-gray-300 bg-white font-bold">
              内容
            </div>
            <div class="ya-te-course-th co-display-13 flex items-center justify-center border-x border-t border-co-gray-300 bg-white font-bold">
              キャリア<br>サポート
            </div>
            <div class="ya-te-course-th co-display-13 flex items-center justify-center border border-co-gray-300 bg-white font-bold">
              価格<br>（税込）
            </div>
          </div>
          <!-- はじめてのWebアプリ開発コース -->
          <div>
            <div class="ya-te-course-table-th-main ya-te-bg-primary co-display-11 flex items-center justify-center font-bold text-white">
              はじめてのWebアプリ<br>開発コース
            </div>
            <div class="ya-te-course-table-cell-main flex flex-col items-center justify-center border-x border-t border-co-gray-300 bg-white">
              <span class="block font-bold">8週間 or 12週間</span>
              <span class="co-display-13 block text-co-gray-500">目安：170時間</span>
            </div>
            <div class="co-display-13 ya-te-course-table-cell-main flex flex-col items-center justify-center border-x border-t border-co-gray-300 bg-white leading-normal">
              Webアプリ基礎<br>HTML/CSS、Java<br>データベースなど
            </div>
            <div class="co-display-13 ya-te-course-table-cell-main flex flex-col items-center justify-center border-x border-t border-co-gray-300 bg-white">
              <FontAwesomeIcon
                :icon="faCircle"
                class="fa-fw co-display-6 mb-1 leading-none"
              />
            </div>
            <div class="ya-te-course-table-cell-main flex flex-col items-center justify-center border border-co-gray-300 bg-white">
              <div class="mb-3 font-bold leading-none">
                8週間<span class="co-display-8 px-1 font-extrabold">275,000</span>円
              </div>
              <div class="font-bold leading-none">
                12週間<span class="co-display-8 px-1 font-extrabold">412,500</span>円
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 補助金制度 -->
    <YaTeCounselingReskilling />

    <!-- まずはお気軽にご相談ください -->
    <YaTeCounselingConsultation :opening="opening">
      <template #leadText>
        カウンセラーが、目標や悩み・疑問も丁寧にヒアリング。<br class="hidden md:block">コースやサポートについての質問はもちろん、働きながら学ぶことやキャリアへの活かし方まで<br class="hidden md:block">なんでもご相談いただけます。
      </template>
      <template #questionImage01>
        <img
          class="mx-auto md:mx-0"
          src="~/assets/images/YaTe/YaTeCounseling/Consultation/question-1-ly.svg"
          alt="本当に未経験からでも転職できるの？"
          width="207"
          height="98"
          loading="lazy"
        >
      </template>
      <template #questionImage02>
        <img
          class="mx-auto md:mx-0"
          src="~/assets/images/YaTe/YaTeCounseling/Consultation/question-2-ly.svg"
          alt="ITエンジニアの仕事って自分に向いているの？"
          width="207"
          height="98"
          loading="lazy"
        >
      </template>
    </YaTeCounselingConsultation>

    <!-- 手厚いキャリアサポート -->
    <section class="ya-te-bg-gray">
      <div class="co-container-xs mx-auto px-4 py-20">
        <h2 class="ya-te-page-title ya-te-text-primary mb-8 text-center font-extrabold leading-normal sm:mb-12">
          <span class="co-display-11 mb-2 block font-bold">
            専属のキャリアカウンセラーによる
          </span>
          手厚いキャリアサポート
        </h2>
        <div class="flex flex-col justify-center gap-8 md:flex-row md:gap-8">
          <div class="flex w-full flex-col justify-center md:w-1/2 md:px-4">
            <img
              class="mb-3"
              src="~/assets/images/YaTe/YaTeCounseling/CareerSupport/career-support-1.svg"
              alt="現職活用・キャリアに関する充実したアドバイス"
              width="288"
              height="60"
              loading="lazy"
            >
            <p class="co-display-13">
              業務での活用に関するアドバイスや、キャリアの自己分析サポートが受けられます。
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 他スクールとの比較 -->
    <YaTeCounselingComparison :is-career-support="true">
      <template #lyCareerSupport>
        一人ひとりに合わせた
        <br>
        手厚いサポート
      </template>
    </YaTeCounselingComparison>

    <!-- まずはお気軽にご相談ください -->
    <YaTeCounselingConsultation :opening="opening">
      <template #leadText>
        カウンセラーが、目標や悩み・疑問も丁寧にヒアリング。<br class="hidden md:block">コースやサポートについての質問はもちろん、働きながら学ぶことやキャリアへの活かし方まで<br class="hidden md:block">なんでもご相談いただけます。
      </template>
      <template #questionImage01>
        <img
          class="mx-auto md:mx-0"
          src="~/assets/images/YaTe/YaTeCounseling/Consultation/question-1-ly.svg"
          alt="本当に未経験からでも転職できるの？"
          width="207"
          height="98"
          loading="lazy"
        >
      </template>
      <template #questionImage02>
        <img
          class="mx-auto md:mx-0"
          src="~/assets/images/YaTe/YaTeCounseling/Consultation/question-2-ly.svg"
          alt="ITエンジニアの仕事って自分に向いているの？"
          width="207"
          height="98"
          loading="lazy"
        >
      </template>
    </YaTeCounselingConsultation>

    <!-- こんな話が聞けます -->
    <section class="co-container-md px-4 py-20">
      <h2 class="ya-te-page-title ya-te-text-primary mb-6 text-center font-extrabold">
        <span class="co-display-11 mb-2 inline-block font-bold">無料相談で</span>
        <br>
        こんな話が聞けます
      </h2>
      <p class="mb-12 text-center">
        1回最大60分、最大3回まで無料でご相談いただけます。
        <span class="block">とりあえず説明を聞いてみたい、軽く質問したいという方もお気軽にご参加ください。</span>
      </p>

      <div class="ya-te-question-area mt-12 flex flex-col justify-between sm:flex-row">
        <div class="ya-te-question-wrap relative bg-white px-4 py-7 text-center md:px-8 lg:px-12 lg:py-10">
          <h3 class="co-display-10 mb-4 font-bold">
            プログラミングについて
          </h3>
          <ul class="m-0 list-none p-0 text-left">
            <li class="co-display-11 mb-1 flex items-center text-co-gray-600">
              <FontAwesomeIcon
                :icon="faCheck"
                class="fa-fw ya-te-text-green pr-2"
              />
              文系/未経験/年齢に関係なく学べる？
            </li>
            <li class="co-display-11 mb-1 flex items-center text-co-gray-600">
              <FontAwesomeIcon
                :icon="faCheck"
                class="fa-fw ya-te-text-green pr-2"
              />
              他のスキルと比べて何がいいの？
            </li>
            <li class="co-display-11 flex items-center text-co-gray-600">
              <FontAwesomeIcon
                :icon="faCheck"
                class="fa-fw ya-te-text-green pr-2"
              />
              自分に合っているか確認したい
            </li>
          </ul>
          <div class="ya-te-question-decoration absolute">
            <img
              src="~/assets/images/YaTe/YaTeCounseling/Topics/question-decoration.svg"
              alt=""
              width="40"
              height="40"
              loading="lazy"
            >
          </div>
        </div>
        <div class="ya-te-question-wrap relative bg-white px-4 py-7 text-center md:px-8 lg:px-12 lg:py-10">
          <h3 class="co-display-10 mb-4 font-bold">
            学習について
          </h3>
          <ul class="m-0 list-none p-0 text-left">
            <li class="co-display-11 mb-1 flex items-center text-co-gray-600">
              <FontAwesomeIcon
                :icon="faCheck"
                class="fa-fw ya-te-text-green pr-2"
              />
              独学や他のスクールとの違いは何？
            </li>
            <li class="co-display-11 mb-1 flex items-center text-co-gray-600">
              <FontAwesomeIcon
                :icon="faCheck"
                class="fa-fw ya-te-text-green pr-2"
              />
              学習時間の確保について悩んでいる
            </li>
            <li class="co-display-11 flex items-center text-co-gray-600">
              <FontAwesomeIcon
                :icon="faCheck"
                class="fa-fw ya-te-text-green pr-2"
              />
              学習の途中で挫折しないか不安
            </li>
          </ul>
          <div class="ya-te-question-decoration absolute">
            <img
              src="~/assets/images/YaTe/YaTeCounseling/Topics/question-decoration.svg"
              alt=""
              width="40"
              height="40"
              loading="lazy"
            >
          </div>
        </div>
      </div>

      <div class="ya-te-question-area mb-20 mt-4 flex flex-col justify-center sm:mt-12 sm:flex-row">
        <div class="ya-te-question-wrap relative bg-white px-4 py-7 text-center md:px-8 lg:px-12 lg:py-10">
          <h3 class="co-display-10 mb-4 font-bold">
            受講料について
          </h3>
          <ul class="m-0 list-none p-0 text-left">
            <li class="co-display-11 mb-1 flex items-center text-co-gray-600">
              <FontAwesomeIcon
                :icon="faCheck"
                class="fa-fw ya-te-text-green pr-2"
              />
              <span>リスキリング補助制度って何？</span>
            </li>
            <li class="co-display-11 mb-1 flex items-center text-co-gray-600">
              <FontAwesomeIcon
                :icon="faCheck"
                class="fa-fw ya-te-text-green pr-2"
              />
              <span>自分は補助金の対象に該当するの？</span>
            </li>
            <li class="co-display-11 flex items-center text-co-gray-600">
              <FontAwesomeIcon
                :icon="faCheck"
                class="fa-fw ya-te-text-green pr-2"
              />
              <span>どのような支払い方法があるの？</span>
            </li>
          </ul>
          <div class="ya-te-question-decoration absolute">
            <img
              src="~/assets/images/YaTe/YaTeCounseling/Topics/question-decoration.svg"
              alt=""
              width="40"
              height="40"
              loading="lazy"
            >
          </div>
        </div>
      </div>

      <!-- 学習体験もついてくる -->
      <img
        src="~/assets/images/YaTe/YaTeCounseling/Topics/experience-title.svg"
        alt="学習体験もついてくる"
        width="297"
        height="29"
        class="mx-auto mb-5"
        loading="lazy"
      >
      <div class="flex flex-row items-center justify-center gap-5">
        <img
          src="~/assets/images/YaTe/YaTeCounseling/Topics/experience-img.svg"
          alt="オンライン学習"
          width="80"
          height="56"
          loading="lazy"
        >
        <p>
          実際の学習システムを用いたオンライン学習が体験できます。
          <br>
          学習のイメージを持っていただくためにぜひご利用ください。
        </p>
      </div>
    </section>

    <!-- 相談した方の声 -->
    <YaTeCounselingVoice />

    <!-- 無料相談の特典 -->
    <YaTeCounselingSpecial class="!bg-white" />

    <!-- 無料相談を予約する -->
    <section
      id="schedule"
      class="ya-te-bg-gray py-20"
    >
      <div class="co-container-xs">
        <div v-if="opening">
          <div class="px-4">
            <h2 class="ya-te-page-title ya-te-text-primary mb-8 text-center font-extrabold sm:mb-12">
              無料相談を予約する
            </h2>
            <p class="co-display-12 mb-5 text-center">
              学習やサービスの内容についてなど、最大60分間なんでもご相談いただけます。
            </p>
            <div class="ya-te-text-red flex items-center justify-center">
              <div class="mr-2 flex items-center justify-center">
                <FontAwesomeIcon
                  :icon="faClockNine"
                  class="fa-fw co-display-10 size-5"
                />
              </div>
              <div class="co-display-12 text-left font-bold">
                当日1時間後<span class="co-display-14 font-bold">から</span>8:00〜24:00<span class="co-display-14 font-bold">まで</span>予約可
              </div>
            </div>
            <div class="co-display-13 mb-2 mt-4 sm:mt-8">
              ※下記の表から<span class="ya-te-text-green">○</span>のアイコンを選択すると登録フォームが表示されますので必要項目を入力してご予約ください。
            </div>
          </div>
          <!-- 予約日程カレンダー -->
          <YaTeCounselingCalendar
            :appointment-form="appointmentForm"
            :appointment-form-table="appointmentFormTable"
            :courses="null"
            :purpose="null"
            :course-screen-name="courseScreenName"
          />
        </div>

        <!-- 受付終了 -->
        <div
          v-else
          class="co-display-11 px-4 text-center font-bold"
        >
          無料相談の受付は終了しました
        </div>
      </div>
    </section>

    <!-- 下部固定ボタン -->
    <YaTeCommonButtonFixedBottom />
  </div>
</template>

<script lang="ts">
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from  '~/utility/constants/metaTags'
import {
  getTrialMiniCourseSchedule,
  getTrialMiniCourseScheduleTable,
} from '~/utility/fetchAPI'

import YaTeCounselingSpecial from '~/components/YaTe/YaTeCounseling/YaTeCounselingSpecial.vue'
import YaTeCounselingTarget from '~/components/YaTe/YaTeCounseling/YaTeCounselingTarget.vue'
import YaTeCounselingFeatures from '~/components/YaTe/YaTeCounseling/YaTeCounselingFeatures.vue'
import YaTeCounselingStatistics from '~/components/YaTe/YaTeCounseling/YaTeCounselingStatistics.vue'
import YaTeCounselingConsultation from '~/components/YaTe/YaTeCounseling/YaTeCounselingConsultation.vue'
import YaTeCounselingCurriculum from '~/components/YaTe/YaTeCounseling/YaTeCounselingCurriculum.vue'
import YaTeCounselingMentorSupport from '~/components/YaTe/YaTeCounseling/YaTeCounselingMentorSupport.vue'
import YaTeCounselingReskilling from '~/components/YaTe/YaTeCounseling/YaTeCounselingReskilling.vue'
import YaTeCounselingVoice from '~/components/YaTe/YaTeCounseling/YaTeCounselingVoice.vue'
import YaTeCounselingComparison from '~/components/YaTe/YaTeCounseling/YaTeCounselingComparison.vue'
import YaTeCounselingCalendar from '~/components/YaTe/YaTeCounseling/YaTeCounselingCalendar.vue'
import YaTeCommonButtonFixedBottom from '~/components/YaTe/YaTeCommon/YaTeCommonButtonFixedBottom.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircle, faClockNine } from '@awesome.me/kit-65d95819ce/icons/classic/regular'
import { faCheck } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    definePageMeta({
      layout: 'yate-counseling'
    })

    return {
      faCircle,
      faCheck,
      faClockNine,
    }
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'yahoo',
    })
    return {
      title: 'LINEヤフーテックアカデミー無料相談 | テックアカデミー',
      meta: [
        ...metaTags(
          {
            keywords:
              'プログラミング, ブートキャンプ, エンジニア, パーソナルメンター',
            description:
              'LINEヤフーテックアカデミーのお申し込み前に利用できる無料相談',
            twitterTitle:
              'LINEヤフーテックアカデミー無料相談 | テックアカデミー',
            twitterDescription:
              'LINEヤフーテックアカデミーのお申し込み前に利用できる無料相談',
            twitterImage: '/_nuxt/ogp/yate/og-image.jpg',
            ogTitle: 'LINEヤフーテックアカデミー無料相談 | テックアカデミー',
            ogDescription:
              'LINEヤフーテックアカデミーのお申し込み前に利用できる無料相談',
            ogUrl: '/ly/lp/counseling',
            ogImage: '/_nuxt/ogp/yate/og-image.jpg',
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  data() {
    return {
      appointmentForm: null,
      appointmentFormTable: null,
      opening: true,
      courseScreenName: 'ly-trial',
    }
  },
  async mounted() {
    // フォーム中の項目の取得
    getTrialMiniCourseSchedule(this.$api, this.courseScreenName, {
      category: 'yahoo',
    }).then((response: any) => {
      this.appointmentForm = response
    })
    // 指定のコースの空席状況の取得
    getTrialMiniCourseScheduleTable(this.$api, this.courseScreenName, {
      range: 2,
    }).then((response) => {
      this.appointmentFormTable = response
    })
  },
  components: {
    YaTeCounselingSpecial,
    YaTeCounselingTarget,
    YaTeCounselingFeatures,
    YaTeCounselingStatistics,
    YaTeCounselingConsultation,
    YaTeCounselingCurriculum,
    YaTeCounselingMentorSupport,
    YaTeCounselingReskilling,
    YaTeCounselingComparison,
    YaTeCounselingVoice,
    YaTeCounselingCalendar,
    YaTeCommonButtonFixedBottom,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
@import url("~/assets/css/YaTe/YaTeCommon/YaTeCommonFontsLINESeedJP.css");
@import url("~/assets/css/YaTe/YaTeCommon/YaTeCommon.css");

/* カバー */
.ya-te-lp-cover-area {
  height: auto;
  overflow: hidden;
  background-image: url('~/assets/images/YaTe/YaTeCounseling/Cover/bg_ly_lp_man.jpg');
  background-repeat: no-repeat;
  background-position: top center;
  background-size: auto 12.125rem;
  @media (max-width: 767.98px) {
    max-width: 23.4375rem;
    margin: 0 auto;
  }
  @media (min-width: 768px) {
    background-position: 145% 0;
    background-size: auto 100%;
  }
  @media (min-width: 1200px) {
    background-position: right;
  }
}

.ya-te-lp-cover-title {
  @media (max-width: 991.98px) {
    width: 21.4375rem;
    height: 6.75rem;
  }
}

/* ボタン */
.ya-te-btn {
  width: 100%;
  max-width: 18.75rem;
  background: #225cff;
  border-radius: 3.125rem;
  @media (min-width: 768px) {
    max-width: 20.25rem;
  }
  span {
    font-size: 1rem;
    @media (min-width: 768px) {
      font-size: 1.5rem;
    }
  }
}

.ya-te-btn-label {
  top: 0;
  right: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.ya-te-btn-label-inner {
  border-color: #225cff;
  span {
    font-size: 0.875rem;
    color: #225cff;
  }
}

/* コースのご案内 */
.ya-te-course-table {
  @media (max-width: 767.98px) {
    overflow-x: scroll;
  }
}

.ya-te-course-th {
  width: 5rem;
  min-height: 5.9375rem;
  line-height: 1.5;
  @media (min-width: 768px) {
    width: 6.5rem;
  }
}

.ya-te-course-table-th-main {
  width: 13.875rem;
  min-height: 5.375rem;
  line-height: 1.5;
  @media (min-width: 768px) {
    width: 18.75rem;
  }
}

.ya-te-course-table-cell-main {
  width: 13.875rem;
  min-height: 5.9375rem;
  @media (min-width: 768px) {
    width: 18.75rem;
  }
}

/* こんな話が聞けます */
.ya-te-question-area {
  gap: 1rem;
  @media (min-width: 996px) {
    gap: 2.5rem;
  }
}

.ya-te-question-wrap {
  border: 0.1875rem solid #cdf4dd;
  border-radius: 0.5rem;
  @media (min-width: 576px) {
    width: 50%;
  }
}

.ya-te-question-decoration {
  right: -0.25rem;
  bottom: -0.25rem;
}
</style>
